import { render } from "./Cloading.vue?vue&type=template&id=ff735eea&scoped=true&ts=true"
import script from "./Cloading.vue?vue&type=script&lang=ts"
export * from "./Cloading.vue?vue&type=script&lang=ts"

import "./Cloading.vue?vue&type=style&index=0&id=ff735eea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff735eea"]])

export default __exports__